import axios from 'axios';
import { API_BASE_URL } from './apiBaseUrl';

// Create a base axios instance for API calls
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true
});

// Add authentication token to requests
apiClient.interceptors.request.use(async (config) => {
  // Add JWT token for authentication if available
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Mark if this request has already been retried to prevent infinite loops
  if (!config.retryCount) {
    config.retryCount = 0;
  }
  
  return config;
});

// Add response interceptor to handle token issues
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    
    // Prevent infinite retry loops - only retry once
    if (originalRequest.retryCount >= 1) {
      return Promise.reject(error);
    }
    
    // Handle 401 Unauthorized errors (token expired/invalid)
    if (error.response && error.response.status === 401) {
      // Clear token
      localStorage.removeItem('token');
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;